import $ from 'gridstrap/lib/gs-zepto';

import { screenshotCarousel } from '../screenshot-carousel';


export class GSProductReviewSummary {

	//
	// Properties
	//

	private root;
	private screenshot;

	get src() {
		return this.screenshot.data('gsProductReviewSummaryScreenshot');
	}

	get isOverflowing() {
		const el = this.screenshot.get(0);
		return el.scrollHeight > el.clientHeight
	}

	//
	// Initializations & Event Handlers
	//

	constructor(root) {
		this.root = $(root);
		this.screenshot = this.root.find('.gs-ProductReviewSummary-screenshotWrapper');

		if (this.src) {
			this.screenshot.on('click', () => screenshotCarousel.open(this.src));
		}
	}

	gsOnDestroy() {
		this.screenshot.off();
	}

	gsOnWindowResize() {
		this.screenshot.toggleClass('is-overflowing', this.isOverflowing);
	}
}
